/* RECENT (docs/design/inbox.md §7, R3267). The folded line wears the line
   of SINCE YOU LEFT (`sinceleft.css`); the rows are one line each, the
   wall time and the words, and every row ends in an ellipsis, never a
   wrap. Every rule reads the tokens of gen/tokens.css and stands under #ui. */

@import '../../gen/tokens.css';

#ui .rc-rows {
  display: flex;
  flex-direction: column;
  padding: var(--s-1) 0;
}
#ui .rc-row {
  display: flex;
  align-items: baseline;
  gap: var(--s-3);
  min-height: 24px;
  padding: 0 var(--s-1);
  font: var(--t-small);
  color: var(--text);
  white-space: nowrap;
}
#ui .rc-row > i {
  flex: none;
  font-style: normal;
  color: var(--dim);
  font-variant-numeric: tabular-nums;
}
#ui .rc-row > span { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; }
#ui .rc-row.bad > span { color: var(--bad); }
